import { Textbox } from '@phosphor-icons/react';

export default Textbox;
